// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	GuaranteedReplacementCoverageCheckbox:
		'guaranteed-replacement-coverage-checkbox',
	InterestOfAllMortgageesHaveBeenNotedCheckbox:
		'interest-of-all-mortgagees-have-been-noted-checkbox',
	ActiveDateDatePicker: 'active-date-date-picker',
	ExpiryDateDatePicker: 'expiry-date-date-picker',
	FireInsuranceCompanyCard: 'fire-insurance-company-card',
	FireInsuranceBrokerageCard: 'fire-insurance-brokerage-card',
	PolicyOrBinderNumber: 'policy-or-binder-number',
	CoverageAmount: 'coverage-amount',
	TypeRadioGroup: 'type-radio-group',
} as const;
